import gql from 'graphql-tag';

import type { org_coursera_diagnostics_DiagnosticProgressState as DiagnosticProgressState } from 'bundles/program-skills-objectives/components/ProgramSkillsObjectivesPage/__generated__/globalTypes';

import type { org_coursera_diagnostics_DiagnosticProgressState } from './__generated__/globalTypes';

export type LevelSetAttempt = {
  skillId: string;
  progressState: DiagnosticProgressState;
  totalAttempts: number;
  attemptsLeft: number;
};

export type LevelSetContent = {
  skillName: string;
  numberOfQuestions: number;
  duration: number;
};

export const LevelSetsAttemptsQuery = gql`
  query LevelSetAttemptsByUserAndSkillQuery($userId: String!, $skillIds: [String!]!) {
    LevelSetsAttemptsQuery(userId: $userId, skillIds: $skillIds)
      @rest(
        type: "LevelSetAttemptsV1"
        path: "levelSetAttempts.v1?q=byUserAndSkillIds&userId={args.userId}&skillIds={args.skillIds}&fields=progressState,attemptsLeft,totalAttempts"
        method: "GET"
      ) {
      elements @type(name: "LevelSetsAttemptsQuery") {
        id
        attemptsLeft
        totalAttempts
        progressState
      }
    }
  }
`;
export type LevelSetsAttemptsVariables = {
  userId: string;
  skillIds: string;
};
export type LevelSetsAttemptsResults = {
  LevelSetsAttemptsQuery: {
    elements: {
      id: string;
      attemptsLeft: number;
      totalAttempts: number;
      progressState: org_coursera_diagnostics_DiagnosticProgressState;
    }[];
  };
};

export const LevelSetsContentQuery = gql`
  query LevelSetContentMultiGetQuery($ids: [String!]!) {
    LevelSetsContentQuery(ids: $ids)
      @rest(
        type: "LevelSetContentV1"
        path: "levelSetContent.v1?ids={args.ids}&fields=description,numberOfQuestions,duration"
        method: "GET"
      ) {
      elements @type(name: "LevelSetsContentQuery") {
        id
        skillName
        duration
        description
        numberOfQuestions
      }
    }
  }
`;

export type LevelSetsContentResults = {
  LevelSetsContentQuery: {
    elements: {
      id: string;
      skillName: string;
      description: string[];
      duration: number;
      numberOfQuestions: number;
    }[];
  };
};

export type LevelSetsContentVariables = {
  ids: string;
};
